import { memo } from 'react'
import DynamicQuestionItem from './DynamicQuestionItem'

// items
// render, group
const DynamicQuestionWrapper = ({ questions }) => {
  if (!Array.isArray(questions)) {
    return null
  }
  return (
    <div>
      {questions.map(question => {
        return <DynamicQuestionItem question={question} key={`${question.fieldDisplayPosition}.${question.fieldId}`}/>
      })}
    </div>
  )
}

export default memo(DynamicQuestionWrapper)
